<template>
    <v-card elevation="2" outlined>
        <v-card-title>
            جزئیات درخواست شخص حقوقی
            <v-spacer/>
            <v-icon>mdi-information</v-icon>
        </v-card-title>

        <v-divider/>

        <v-list>
            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-office-building-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.name"/>
                    <v-list-item-subtitle>نام شرکت</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-store-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.registration_number"/>
                    <v-list-item-subtitle>شماره شناسنامه</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-police-badge</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.economic_code"/>
                    <v-list-item-subtitle>کد اختصاصی</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-clipboard-list</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.organization_identity"/>
                    <v-list-item-subtitle>هویت سازمانی</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-ticket</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.activity"/>
                    <v-list-item-subtitle>فعالیت</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-advertisements</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.registration_ad"/>
                    <v-list-item-subtitle>اگهی ثبت نام</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-clipboard-text-clock</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.last_published_ad"/>
                    <v-list-item-subtitle>آخرین آگهی منتشر شده</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-scale-balance</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.statute"/>
                    <v-list-item-subtitle>اساسنامه</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-face-agent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="request.bussiness.agent_letterpic"/>
                    <v-list-item-subtitle>نماینده</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-format-list-bulleted-type</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-if="request.bussiness.company_type == 'governmental'" v-text="'دولتی'"/>
                    <v-list-item-title v-if="request.bussiness.company_type == 'private'" v-text="'خصوصی'"/>
                    <v-list-item-title v-if="request.bussiness.company_type == 'common_stock'" v-text="'سهامی عام'"/>
                    <v-list-item-title v-if="request.bussiness.company_type == 'special_stock'" v-text="'سهامی خاص'"/>
                    <v-list-item-subtitle>نوع شرکت</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


        </v-list>
    </v-card>
</template>

<script>
export default {
    props: ['request'],
}
</script>
